import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { 'Content-Type': 'application/json' },
});

// Attach token for admin requests automatically
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('vvvsi_admin_token');
    if (token && config.url && config.url.startsWith('/admin')) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (token && config.url && config.url.startsWith('/auth/me')) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Public helpers
export const publicApi = {
    getSiteSettings: () => api.get('/public/site-settings').then((r) => r.data),
    getImpactStats: () => api.get('/public/impact-stats').then((r) => r.data),
    getServices: () => api.get('/public/services').then((r) => r.data),
    getProjects: (status) =>
        api.get('/public/projects', { params: status ? { status } : {} }).then((r) => r.data),
    getProject: (id) => api.get(`/public/projects/${id}`).then((r) => r.data),
    getTestimonials: () => api.get('/public/testimonials').then((r) => r.data),
    getNews: () => api.get('/public/news').then((r) => r.data),
    getNewsDetail: (id) => api.get(`/public/news/${id}`).then((r) => r.data),
    getGallery: (type) =>
        api.get('/public/gallery', { params: type ? { type } : {} }).then((r) => r.data),
    getPartners: () => api.get('/public/partners').then((r) => r.data),
    getDownloads: () => api.get('/public/downloads').then((r) => r.data),
    getMediaAwards: (mediaCategory) =>
        api
            .get('/public/media-awards', { params: mediaCategory ? { media_category: mediaCategory } : {} })
            .then((r) => r.data),
    getHome: () => api.get('/public/home').then((r) => r.data),
    submitVolunteer: (data) => api.post('/public/volunteers', data).then((r) => r.data),
    submitContact: (data) => api.post('/public/contacts', data).then((r) => r.data),
    submitDonation: (data) => api.post('/public/donations', data).then((r) => r.data),
    // Phase A additions
    getAdvisors: () => api.get('/public/advisors').then((r) => r.data),
    getSectors: () => api.get('/public/sectors').then((r) => r.data),
    getAssociations: () => api.get('/public/associations').then((r) => r.data),
    getProposalProjects: () => api.get('/public/proposal-projects').then((r) => r.data),
    getProposalProject: (id) => api.get(`/public/proposal-projects/${id}`).then((r) => r.data),
    getSectorAchievements: () => api.get('/public/sector-achievements').then((r) => r.data),
    getSectorAchievementBySlug: (slug) =>
        api.get(`/public/sector-achievements/${slug}`).then((r) => r.data),
    getContentBlocks: (keyPrefix) =>
        api
            .get('/public/content-blocks', { params: keyPrefix ? { key_prefix: keyPrefix } : {} })
            .then((r) => r.data),
    getContentBlock: (key) => api.get(`/public/content-blocks/${key}`).then((r) => r.data),
    // Phase B additions
    getServiceYearStats: () => api.get('/public/service-year-stats').then((r) => r.data),
    getVolunteerAlbums: () => api.get('/public/volunteer-albums').then((r) => r.data),
    getVolunteerAlbum: (id) => api.get(`/public/volunteer-albums/${id}`).then((r) => r.data),
    getCsrProjectPdfs: (tier) =>
        api
            .get('/public/csr-project-pdfs', { params: tier ? { tier } : {} })
            .then((r) => r.data),
    getGalleryAlbums: (category) =>
        api
            .get('/public/gallery-albums', { params: category ? { category } : {} })
            .then((r) => r.data),
    getGalleryAlbum: (id) => api.get(`/public/gallery-albums/${id}`).then((r) => r.data),
};

// Admin helpers
export const adminApi = {
    login: (email, password) =>
        api.post('/auth/login', { email, password }).then((r) => r.data),
    me: () => api.get('/auth/me').then((r) => r.data),
    dashboard: () => api.get('/admin/dashboard').then((r) => r.data),
    // Content CRUD
    list: (resource) => api.get(`/admin/${resource}`).then((r) => r.data),
    create: (resource, data) => api.post(`/admin/${resource}`, data).then((r) => r.data),
    update: (resource, id, data) =>
        api.put(`/admin/${resource}/${id}`, data).then((r) => r.data),
    remove: (resource, id) => api.delete(`/admin/${resource}/${id}`).then((r) => r.data),
    // Site settings
    getSiteSettings: () => api.get('/public/site-settings').then((r) => r.data),
    updateSiteSettings: (data) => api.put('/admin/site-settings', data).then((r) => r.data),
    // Submissions
    listSubmissions: (kind, params) =>
        api.get(`/admin/${kind}`, { params }).then((r) => r.data),
    markRead: (kind, id, isRead = true) =>
        api.put(`/admin/${kind}/${id}/read`, { is_read: isRead }).then((r) => r.data),
    deleteSubmission: (kind, id) =>
        api.delete(`/admin/${kind}/${id}`).then((r) => r.data),
};
